/**
 * Calculate the color value for progress bars based on metric type
 *
 * For SOA (Share of Attention), we normalize values above 30% to 100% on the color scale
 * This makes SOA values above 30% map to green (100% color scale)
 * while keeping the actual displayed percentage unchanged
 *
 * @param value - The metric value (as a percentage)
 * @param metric - The metric type
 * @returns The color value to be used for progress bar
 */
export const getMetricColorValue = (value: number, metric: string): number => {
  if (metric === "soa") {
    return Math.min(1, value / 30.0) * 100;
  }
  return value;
};
